import {Checkbox} from '@mui/material'
import Icon, {type TIconName} from '../icon'
import PopoverButton from '../Popover'
import './styles.css'
import '../../styles/filterPanel.css'
import {theme} from '../../theme'

export interface TFilterItem {
  id: string
  label: string
  colorDot?: string
  icon?: TIconName
}

interface FilterPopoverProps {
  items: TFilterItem[]
  selectedIds: string[]
  onToggle: (id: string) => void
  buttonIcon: TIconName
  tooltip?: string
  // When set, the trigger shows the concept name next to the icon (icon +
  // label). The button widens to fit; without it the button stays icon-only.
  buttonLabel?: string
}

export default function FilterPopover({
  items,
  selectedIds,
  onToggle,
  buttonIcon,
  tooltip,
  buttonLabel,
}: FilterPopoverProps) {
  const isActive = selectedIds.length > 0

  if (items.length === 0) {
    return null
  }

  return (
    <PopoverButton
      buttonIcon={buttonIcon}
      buttonText={buttonLabel}
      buttonClassName={
        buttonLabel ? 'actionButton actionButtonLabeled' : 'actionButton'
      }
      tooltip={tooltip}
      isActive={isActive}>
      <div className='popoverContent'>
        {items.map(item => (
          <div
            key={item.id}
            className='filterItem'
            onClick={e => {
              e.stopPropagation()
              onToggle(item.id)
            }}>
            <div className='filterLabelWrapper'>
              {item.colorDot && (
                <div
                  className='filterColorDot'
                  style={{backgroundColor: item.colorDot}}
                />
              )}
              {item.icon && (
                <Icon
                  type={item.icon}
                  size='20px'
                  color={theme.palette.text.primary}
                />
              )}
              <label>{item.label}</label>
            </div>
            <Checkbox
              onChange={e => {
                e.stopPropagation()
              }}
              checked={selectedIds.includes(item.id)}
              sx={{'&': {padding: '0px'}}}
            />
          </div>
        ))}
      </div>
    </PopoverButton>
  )
}
